import { authGet } from "@api/auth/auth";
import { UserInvite } from "@types";

export const fetchUserInviteByRegistrationToken = (
  registration_token: string,
  expand_organization: boolean = false
): Promise<UserInvite> => {
  const arg_registration_token = `registration_token=${registration_token}`;
  const arg_expand_organization = `expand_organization=${expand_organization.toString()}`;
  return authGet<{ user_invite: UserInvite }>(
    `/api/agent/user_invites?${arg_registration_token}&${arg_expand_organization}`
  ).then((response) => response.user_invite);
};
